export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Articles',
    pathname: '/articles',
  },
  {
    label: 'Certificates',
    pathname: '/',
    hash: '#certificates',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Mail',
    url: 'mailto:akira.ito0116@gmail.com',
    icon: 'email',
  },
  {
    label: 'Github',
    url: 'https://github.com/developer0116',
    icon: 'github',
  },
  {
    label: 'Telegram',
    url: 'https://t.me/insane_dev',
    icon: 'telegram',
  },
  // {
  //   label: 'Twitter',
  //   url: 'https://x.com/techpreneur16',
  //   icon: 'twitter',
  // },
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/akira-ito-1a21b13a7/',
    icon: 'linkedin',
  },
];
